module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/10-018d49ee1f8a7e851d66cf89b4ddd263.jpg";